export default __webpack_public_path__ + "static/media/happy.48ab6ee5.gif";